import type { FileWithLatestFileVersion } from "schemas/generated/file";

import React from "react";

import PageRenderControls from "@/features/react-editor/components/PageRenderControls";
import { ToggleGroup } from "@replo/design-system/components/toggle/ToggleGroup";
import { MessageSquareMore, Smartphone } from "lucide-react";

type Props = {
  pageId: string | null;
  page: FileWithLatestFileVersion | undefined;
  isLoading: boolean;
  mode: "chat" | "preview";
  onModeChange: (mode: "chat" | "preview") => void;
};

export default function MobileChatFooter({
  pageId,
  page,
  isLoading,
  mode,
  onModeChange,
}: Props) {
  return (
    <div className="md:hidden w-full bg-white shadow-panel p-3 flex flex-col gap-3 border-t-0.5 border-border">
      {mode === "preview" && (
        <PageRenderControls page={page} isLoading={isLoading} />
      )}

      <ToggleGroup
        size="base"
        selectedValue={mode}
        onChange={(v) => onModeChange(v as "chat" | "preview")}
        layoutClassName="h-11"
        options={[
          {
            value: "chat",
            label: (
              <span className="flex items-center gap-2">
                <MessageSquareMore className="size-4" /> Chat
              </span>
            ),
          },
          {
            value: "preview",
            label: (
              <span className="flex items-center gap-2">
                <Smartphone className="size-4" /> Preview
              </span>
            ),
            disabled: !pageId,
          },
        ]}
      />
    </div>
  );
}
